export default "__VITE_ASSET__eceb531f__"